import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';

/** The minimal profile searchUsersForGroup returns: never an email or full phone. */
export interface GroupSearchResult {
  id: string;
  displayName: string;
  photoURL: string | null;
  maskedPhone: string;
}

/**
 * Server-side lookup of people the caller may add to a group
 * (functions/groups/searchUsersForGroup.js): an org group's beneficiaries by
 * name/phone, or a personal group's exact phone match.
 */
export async function searchUsersForGroup(
  groupId: string,
  query: string,
  language: string,
): Promise<GroupSearchResult[]> {
  const call = httpsCallable<
    { groupId: string; query: string; language: 'ar' | 'en' },
    { mode: 'org' | 'personal'; results: GroupSearchResult[] }
  >(functions, 'searchUsersForGroup');
  const res = await call({ groupId, query, language: language === 'en' ? 'en' : 'ar' });
  return res.data.results;
}
